// Payment-rail exposure (pilot-readiness addendum §4.3). The single most persuasive
// number for this audience: accountability visibly increasing as cash shrinks. Pure.

import { PAYMENT_METHODS, type WorkspaceSeed } from "./types";

const TRACEABLE = new Set<string>(PAYMENT_METHODS.filter((m) => m.traceable).map((m) => m.key));

export type RailExposure = {
  total: number;
  traceable: number;
  cash: number;
  /** Share of spend on traceable rails (mobile money / bank / card), 0..1. */
  share: number;
  /** Illustrative pilot trend ending at the current share (seeded ramp + live value). */
  trend: number[];
  /** Target traceable share for the pilot. */
  target: number;
};

export function railExposure(seed: WorkspaceSeed): RailExposure {
  const withMethod = seed.spendRequests.filter((r) => r.paymentMethod && r.state !== "rejected");
  const total = withMethod.reduce((a, r) => a + r.amount, 0);
  const traceable = withMethod
    .filter((r) => r.paymentMethod && TRACEABLE.has(r.paymentMethod))
    .reduce((a, r) => a + r.amount, 0);
  const cash = total - traceable;
  const share = total > 0 ? traceable / total : 1;
  // A seeded ramp over the pilot, ending at the live share so the headline and the line agree.
  const trend = [0.68, 0.73, 0.78, Number(share.toFixed(3))];
  return { total, traceable, cash, share, trend, target: 0.9 };
}
